import React from "react"

const SidebarIcons = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="hidden">
    <defs>
      <symbol id="sidebar-icon-chevron" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M7.41 8.58 12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42Z"
        />
      </symbol>

      <symbol id="sidebar-icon-home" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m12 7.152 4 3.6V17h-1.6v-4.8H9.6V17H8v-6.248l4-3.6ZM12 5l-8 7.2h2.4v6.4h4.8v-4.8h1.6v4.8h4.8v-6.4H20"
        />
      </symbol>

      <symbol id="sidebar-icon-products" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M4.57 4h6.004c.469 0 .909.182 1.24.513l7.673 7.673c.33.331.513.771.513 1.24 0 .467-.182.908-.513 1.238l-4.824 4.824c-.341.341-.79.512-1.238.512-.449 0-.898-.17-1.24-.512l-7.673-7.674A1.74 1.74 0 0 1 4 10.575V4.572c0-.316.256-.572.571-.572Zm8.001 5.143a1.144 1.144 0 1 0 1.143 1.143c0-.63-.513-1.143-1.143-1.143Zm1.143 8A1.144 1.144 0 1 0 12.57 16c0 .63.513 1.143 1.143 1.143Zm-4-3.428h6.857a.571.571 0 1 0 0-1.143H9.714a.571.571 0 1 0 0 1.143ZM7.428 9.143c.945 0 1.714-.769 1.714-1.714 0-.946-.769-1.714-1.714-1.714-.946 0-1.714.768-1.714 1.714 0 .945.768 1.714 1.714 1.714Z"
        />
        <circle cx="13.079" cy="13.08" r="4.857" fill="currentColor" />
      </symbol>

      <symbol id="sidebar-icon-stock" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M4.573 6.63h3.065c.236.811.943 1.406 1.785 1.406s1.55-.595 1.785-1.405h8.22c.32 0 .572-.27.572-.613 0-.342-.253-.612-.573-.612h-8.202C10.973 4.612 10.265 4 9.423 4c-.842 0-1.55.613-1.785 1.423H4.573c-.32 0-.573.27-.573.613 0 .342.253.595.573.595ZM19.427 11.387h-3.065c-.236-.81-.943-1.405-1.785-1.405s-1.55.595-1.785 1.405h-8.22c-.32 0-.572.27-.572.613 0 .342.253.613.573.613h8.219c.235.81.943 1.405 1.785 1.405s1.55-.595 1.785-1.405h3.065c.32 0 .573-.27.573-.613 0-.342-.253-.613-.573-.613ZM19.427 17.37h-8.202c-.236-.811-.943-1.406-1.785-1.406s-1.55.595-1.785 1.405H4.573c-.32 0-.573.27-.573.613 0 .342.253.613.573.613h3.065c.236.81.943 1.405 1.785 1.405s1.55-.595 1.785-1.405h8.22c.32 0 .572-.27.572-.613 0-.342-.253-.613-.573-.613Z"
        />
      </symbol>

      <symbol id="sidebar-icon-reporting" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m19.998 4.577-.27 3.174c-.024.281-.283.494-.587.494l-.045-.001c-.324-.022-.567-.281-.541-.576l.105-1.228-5.188 7.114c-.16.22-.47.3-.733.191l-1.046-.435-2.175 3.17a.616.616 0 0 1-.618.242l-.82-.155-2.212 2.36h13.01c.326 0 .589.241.589.536 0 .297-.263.537-.588.537H4.588C4.264 20 4 19.76 4 19.463V6.431c0-.297.265-.537.588-.537.326 0 .589.24.589.537v11.581L7.41 15.63a.618.618 0 0 1 .567-.177l.76.143 2.23-3.253a.621.621 0 0 1 .743-.203l1.06.44 4.862-6.67-1.114.485c-.294.127-.645.014-.785-.252-.14-.269-.017-.59.277-.716l3.148-1.374a.637.637 0 0 1 .587.043.518.518 0 0 1 .252.482Z"
        />
      </symbol>

      <symbol id="sidebar-icon-orders" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m19.984 8.548-1.551 6.203a1.102 1.102 0 0 1-1.07.835H7.801c-.56 0-1.032-.42-1.096-.975L5.588 5.655h-.76a.827.827 0 1 1 0-1.655H6.31c.414 0 .764.305.82.715l.431 3.147h11.887c.359 0 .623.338.536.686ZM7.31 18.345c0 .913.743 1.655 1.655 1.655.913 0 1.655-.742 1.655-1.655s-.742-1.655-1.655-1.655c-.912 0-1.655.742-1.655 1.655ZM17.241 18.345c0-.913-.742-1.655-1.655-1.655-.912 0-1.655.742-1.655 1.655S14.674 20 15.586 20c.913 0 1.655-.742 1.655-1.655Z"
        />
      </symbol>

      <symbol id="sidebar-icon-promotions" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M10.364 7.374c.616 0 1.114.497 1.114 1.113S10.98 9.6 10.364 9.6a1.112 1.112 0 0 1-1.113-1.113c0-.616.497-1.113 1.113-1.113Zm3.711 5.195c.616 0 1.113.497 1.113 1.113s-.497 1.113-1.113 1.113a1.112 1.112 0 0 1-1.113-1.113c0-.616.497-1.113 1.113-1.113Zm-4.52 2.226L8.51 13.75l6.375-6.375L15.93 8.42l-6.374 6.375Zm7.6-10.5.453 2.864 2.604 1.328-1.313 2.598 1.32 2.597-2.626 1.328-.453 2.865-2.887-.453-2.056 2.056-2.063-2.085-2.864.474-.46-2.886-2.59-1.321 1.32-2.598-1.313-2.575 2.605-1.343.453-2.835 2.872.468 2.063-2.082 2.048 2.052 2.887-.453Zm1.076 4.838L16.3 8.116l-.37-2.145-2.153.312-1.558-1.506-1.559 1.506-2.152-.312-.37 2.145-1.93 1.017.964 1.952-.964 1.951 1.93 1.017.37 2.145 2.152-.312 1.559 1.507 1.558-1.507 2.152.312.371-2.145 1.93-1.017-.965-1.951.965-1.952Z"
        />
      </symbol>

      <symbol id="sidebar-icon-delivery-notes" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M13.556 10.444h4.277l-4.277-4.277v4.277ZM6.556 5h7.777L19 9.667v7.777A1.556 1.556 0 0 1 17.444 19H6.556C5.692 19 5 18.3 5 17.444V6.556A1.55 1.55 0 0 1 6.556 5Zm0 1.556v10.888h10.888V12H12V6.556H6.556Z"
        />
      </symbol>

      <symbol id="sidebar-icon-integrations" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M16 7V3h-2v4h-4V3H8v4C7 7 6 8 6 9v5.5L9.5 18v3h5v-3l3.5-3.5V9c0-1-1-2-2-2Zm0 6.67-2.91 2.92-.42.41h-1.34l-.41-.41L8 13.67V9.09c0-.03.06-.09.09-.09h7.83c.03 0 .08.06.08.09v4.58Z"
        />
      </symbol>

      <symbol id="sidebar-icon-marketing" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m4 7.56 4 2.552 4-2.552L8 5 4 7.56Zm8 0 4 2.552 4-2.552L16 5l-4 2.56Zm-8 5.08 4 2.552 4-2.552-4-2.56-4 2.56Zm12-2.56-4 2.56 4 2.552 4-2.552-4-2.56Zm-7.976 5.96 4.008 2.56 4-2.56-4-2.552-4.008 2.552Z"
        />
      </symbol>

      <symbol id="sidebar-icon-community-hub" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M12 6.5a2.333 2.333 0 1 1 0 4.667A2.333 2.333 0 0 1 12 6.5ZM7.333 8.167c.374 0 .72.1 1.02.28-.1.953.18 1.9.754 2.64a1.998 1.998 0 1 1-3.188-2.335 2 2 0 0 1 1.414-.585Zm9.334 0a2 2 0 1 1-1.774 2.92 3.69 3.69 0 0 0 .754-2.64c.3-.18.646-.28 1.02-.28Zm-9 6.833c0-1.38 1.94-2.5 4.333-2.5 2.393 0 4.333 1.12 4.333 2.5v1.167H7.667V15ZM4 16.167v-1c0-.927 1.26-1.707 2.967-1.934A2.696 2.696 0 0 0 6.333 15v1.167H4Zm16 0h-2.333V15c0-.687-.24-1.313-.634-1.767C18.74 13.46 20 14.24 20 15.167v1Z"
        />
      </symbol>

      <symbol id="sidebar-icon-profile" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M12 5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 8.75c3.867 0 7 1.566 7 3.5V19H5v-1.75c0-1.934 3.133-3.5 7-3.5Z"
        />
      </symbol>

      <symbol id="sidebar-icon-account" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M12.27 7.934a3.289 3.289 0 1 1 0 6.578 3.289 3.289 0 0 1 0-6.578Zm0 1.644a1.645 1.645 0 1 0 0 3.29 1.645 1.645 0 0 0 0-3.29Zm-1.644 9.867a.416.416 0 0 1-.411-.345l-.304-2.18a5.712 5.712 0 0 1-1.39-.813l-2.047.83a.413.413 0 0 1-.502-.18L4.328 13.91a.405.405 0 0 1 .098-.526l1.735-1.365-.057-.797.057-.823-1.735-1.34a.405.405 0 0 1-.098-.526l1.644-2.845a.404.404 0 0 1 .502-.181l2.047.822c.428-.32.872-.6 1.39-.806l.304-2.179A.416.416 0 0 1 10.626 3h3.289c.206 0 .378.148.411.345l.304 2.18c.518.205.962.484 1.39.805l2.047-.822c.181-.074.403 0 .502.18l1.645 2.846a.405.405 0 0 1-.1.526L18.38 10.4l.057.823-.057.822 1.735 1.34a.405.405 0 0 1 .099.526l-1.645 2.845c-.099.181-.32.255-.502.181l-2.047-.822c-.428.32-.872.6-1.39.806l-.304 2.179a.416.416 0 0 1-.411.345h-3.289Zm1.028-14.8L11.35 6.79a4.516 4.516 0 0 0-2.492 1.463L6.877 7.4 6.26 8.468l1.735 1.274a4.563 4.563 0 0 0 0 2.96l-1.743 1.283.616 1.07 1.998-.856a4.476 4.476 0 0 0 2.475 1.447l.305 2.155h1.25l.304-2.146a4.536 4.536 0 0 0 2.475-1.456l1.998.855.616-1.069-1.743-1.274a4.588 4.588 0 0 0 0-2.969l1.735-1.274-.616-1.069-1.982.855A4.457 4.457 0 0 0 13.19 6.8l-.304-2.154h-1.233Z"
        />
      </symbol>

      <symbol id="sidebar-icon-help-centre" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M11.2 16.8h1.6v-1.6h-1.6v1.6ZM12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 14.4A6.408 6.408 0 0 1 5.6 12c0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4Zm0-11.2a3.2 3.2 0 0 0-3.2 3.2h1.6a1.6 1.6 0 0 1 3.2 0c0 1.6-2.4 1.4-2.4 4h1.6c0-1.8 2.4-2 2.4-4A3.2 3.2 0 0 0 12 7.2Z"
        />
      </symbol>

      <symbol id="sidebar-icon-contact-us" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m18.4 8.2-6.4 4-6.4-4V6.6l6.4 4 6.4-4m0-1.6H5.6C4.712 5 4 5.712 4 6.6v9.6a1.6 1.6 0 0 0 1.6 1.6h12.8a1.6 1.6 0 0 0 1.6-1.6V6.6A1.6 1.6 0 0 0 18.4 5Z"
        />
      </symbol>

      <symbol id="sidebar-icon-logout" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="m16 8.2-1.128 1.128 2.064 2.072H8.8V13h8.136l-2.064 2.064L16 16.2l4-4M5.6 6.6H12V5H5.6C4.72 5 4 5.72 4 6.6v11.2c0 .88.72 1.6 1.6 1.6H12v-1.6H5.6V6.6Z"
        />
      </symbol>

      <symbol id="sidebar-icon-payment-centre" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M 18.799314,8.6003434 H 5.2006863 V 6.9005148 H 18.799314 m 0,10.1989712 H 5.2006863 V 12 H 18.799314 m 0,-6.7993138 H 5.2006863 c -0.9434049,0 -1.6998285,0.7564233 -1.6998285,1.6998286 V 17.099486 c 0,0.450793 0.1790888,0.883145 0.4978678,1.201947 0.3187799,0.318803 0.7511406,0.49788 1.2019607,0.49788 H 18.799314 c 0.450794,0 0.883146,-0.179077 1.201949,-0.49788 0.318803,-0.318803 0.497879,-0.751154 0.497879,-1.201947 V 6.9005148 c 0,-0.9434053 -0.764922,-1.6998286 -1.699828,-1.6998286 z"
        />
      </symbol>
    </defs>
  </svg>
)

export default SidebarIcons
